import css from "./mappopup.scss?inline";
import globalStyles from "../../index.scss?inline";
import { Component } from "../../utils/Component";
import { ArgSpecDictionary } from "../component-utils";
import { HHDSIconType } from "../Icon/IconType";
import gsap from "gsap";

const DEBUG_VERBOSE: boolean = false;
const CLASS_NAME: string = "HHDSMapPopup";
export const HHDSMapPopupTagName: string = "hhds-map-popup";
const TAG_NAME: string = HHDSMapPopupTagName;

export const HHDSMapPopupAttrNames = {
  startVisible: "start-visible",
  vAlign: "v-align",
};

const Attrs = HHDSMapPopupAttrNames;

export enum HHDSMapPopupHAlign {
  left = "left",
  right = "right",
}

export enum HHDSMapPopupVAlign {
  top = "top",
  bottom = "bottom",
}

export enum HHDSMapPopupEvent {
  show = "hhds-map-popup-show",
  hide = "hhds-map-popup-hide",
}

export class HHDSMapPopup extends Component {
  showTween: gsap.core.Tween | null = null;
  hideTween: gsap.core.Tween | null = null;
  ignoreNextHideClick: boolean = false;

  constructor() {
    super();
  }

  get focusableElements(): HTMLElement[] {
    const internalButtons = this.shadow.querySelectorAll("hhds-button") as NodeListOf<HTMLElement>;
    let focusable: HTMLElement[] = Array.from(internalButtons);
    focusable.sort((a, b) => {
      const aRect = a.getBoundingClientRect();
      const bRect = b.getBoundingClientRect();
      return aRect.top - bRect.top || aRect.left - bRect.left;
    });
    return focusable;
    /*console.log('Internal focusable buttons:', focusable);
    const contentSlot = this.shadow.querySelector(`slot[name="content"]`);
    const card = contentSlot?.querySelector(HHDSCardTagName) as HHDSCard;
    if (card) {
      const cardButtonSlot = card.shadowRoot?.querySelector(`slot[name="buttons"]`) as HTMLSlotElement;
      if (cardButtonSlot) {
        const cardButtons = cardButtonSlot.assignedElements({ flatten: true }) as HTMLElement[];
        console.log("Focusable card buttons:", cardButtons);
        focusable = focusable.concat(cardButtons);
      }
    }
    return focusable;*/
  }

  protected override init(): void {
    const startVisible: boolean = this.vars.get<Boolean>(Attrs.startVisible);

    const alignClass = (): string => {
      const vAlign: HHDSMapPopupVAlign = this.vars.get<string>(Attrs.vAlign);
      if (vAlign == HHDSMapPopupVAlign.top) return `${TAG_NAME}__slotted-align-top`;
      return `${TAG_NAME}__slotted-align-bottom`;
    };

    this.shadow.innerHTML = `
      <style>${globalStyles}</style>
			<style>${css}</style>
			<div class="${TAG_NAME} ${startVisible ? `${TAG_NAME}--visible` : ``}">
        <div class="${TAG_NAME}__slotted ${alignClass()}">
          <div class="${TAG_NAME}__slotted__inner">
            <slot name="content"></slot>
            <hhds-button class="close" type="square"><hhds-icon type="${HHDSIconType.Cross}"></hhds-icon></hhds-button>
          </div>
        </div>
      </div>
		`;

    const closeButton = this.shadow.querySelector(".close") as HTMLElement;
    if (closeButton) {
      closeButton.addEventListener("click", () => {
        this.hide();
      });
      closeButton.addEventListener("keydown", (event: KeyboardEvent) => {
        if (event.key === "Enter" || event.key === " ") this.hide();
      });
    }
  }

  show(): void {
    this.ignoreNextHideClick = false;

    const component = this.shadow.querySelector(`.${TAG_NAME}`);
    component?.classList.toggle(`${TAG_NAME}--visible`, true);

    const pane = this.shadow.querySelector(`.${TAG_NAME}`) as HTMLElement;
    pane.style.display = "block";

    gsap.set(pane, { opacity: 0, x: -10 });
    this.showTween = gsap.to(pane, {
      duration: 0.3,
      opacity: 1.0,
      x: 0,
    });
    this.emitEvent(HHDSMapPopupEvent.show);
  }

  hide(): void {
    if (this.hideTween?.isActive()) {
      return;
    }

    const pane = this.shadow.querySelector(`.${TAG_NAME}`);
    gsap.set(pane, { x: 0 });
    this.hideTween = gsap.to(pane, {
      duration: 0.3,
      opacity: 0,
      x: -10,
      display: "none",
      onComplete: () => {
        const component = this.shadow.querySelector(`.${TAG_NAME}`);
        component?.classList.toggle(`${TAG_NAME}--visible`, false);
      },
    });
    this.emitEvent(HHDSMapPopupEvent.hide);
  }

  protected override destroy(): void {
    DEBUG_VERBOSE && console.log(CLASS_NAME, "destroy");
  }

  override onAttributeChanged(name: string, _oldValue: string, newValue: string): void {
    DEBUG_VERBOSE && console.log(CLASS_NAME, "Attribute changed: ", name, _oldValue, newValue);
    this.reinit();
  }

  override onSlotChange(_slot: HTMLSlotElement, elements: Element[]): void {
    if (elements.length == 0) {
      DEBUG_VERBOSE && console.log(CLASS_NAME, "Slot emptied");
    } else {
      DEBUG_VERBOSE && console.log(CLASS_NAME, "Slot changed");
    }
  }

  static override argSpecs(): ArgSpecDictionary {
    return ArgSpecs;
  }
}

export const ArgSpecs: ArgSpecDictionary = {
  [Attrs.startVisible]: {
    description: "Show the map popup upon creation",
    defaultValue: false,
    type: Boolean,
  },
  [Attrs.vAlign]: {
    description: "Vertical alignment of the map popup",
    defaultValue: HHDSMapPopupVAlign.top,
    typeString: "HHDSMapPopupVAlign",
    type: Boolean,
  },
};
